<template>
  <div>
    <div class="row">
      <div class="col category-title mt-5"><h5>{{name}}</h5></div>
    </div>
    <div class="row">
        <div
        is="SubCategory"
        v-for="subCategory in subCategories"
        v-bind:key="subCategory.code"
        v-bind:code="subCategory.code"
        v-bind:name="subCategory.name"
        v-on:dishes:choose="onChooseDishes"
        >
      </div>
    </div>
  </div>
</template>

<script>
import SubCategory from './SubCategory'
import { SubCategoriesData } from '../data/data.js'

export default {
  name: 'Category',
  components: {
    SubCategory
  },
  props: {
    name: {
      type: String,
      required: true
    },
    code: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      subCategories: SubCategoriesData[this.code]
    }
  },
  methods: {
    onChooseDishes: function (chosenDishes) {
      this.$emit('dishes:choose', chosenDishes)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Category.vue